/**
 * Slider de correspondance minimum
 */

import React from "react";
import { motion } from "framer-motion";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { glassPanel } from "../../../../components/layout/UserLayout/designTokens";

export default function MatchFilterSection({
  minMatchPercentage,
  setMinMatchPercentage,
  t,
  visible,
}) {
  if (!visible) return null;

  return (
    <motion.div
      className={`${glassPanel} p-4 sm:p-5 rounded-xl mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="flex items-center gap-2">
        <HiOutlineAdjustmentsHorizontal className="w-5 h-5 text-orange-300 flex-shrink-0" />
        <label className="text-sm font-medium text-ink-900 dark:text-white">
          {t("minimumMatch")} <strong>{minMatchPercentage}%</strong>
        </label>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        step="10"
        value={minMatchPercentage}
        onChange={(e) => setMinMatchPercentage(parseInt(e.target.value, 10))}
        className="flex-1 max-w-xs h-2 bg-ink-200 dark:bg-white/20 rounded-lg appearance-none cursor-pointer accent-orange-500"
      />
    </motion.div>
  );
}
